import { Box } from '@bluedolphin/ui';

import { AvatarInitial } from './AvatarInitial';
import { useInitials } from '../../hooks/useIntials';

export const AvatarInitials = ({
    firstName,
    lastName,
}: {
    firstName: string;
    lastName: string;
}) => {
    const initials = useInitials(firstName, lastName);
    return (
        <Box id="avatar_initial">
            <AvatarInitial>{initials}</AvatarInitial>
        </Box>
    );
};
